import { useTranslation } from '@packlink/translation-provider';
import { Typography, Button, ButtonVariant } from '@shipengine/giger';
import { getPriceSectionStyles, getPriceLargeStyles, getAmountHeadingStyles, getAmountTaxStyles, getFeeStyles, getButtonStyles } from './PriceStyles.js';
import { Currency } from '@packlink/packlink-sdk';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const Price = _ref => {
  let {
    price,
    taxPrice,
    appliedTax,
    products,
    onPriceSelect
  } = _ref;
  const {
    t
  } = useTranslation();
  const showTaxInfo = taxPrice !== 0;
  const {
    managementFee
  } = products !== null && products !== void 0 ? products : {};
  return jsxs("section", {
    css: getPriceSectionStyles,
    children: [jsxs("div", {
      css: getPriceLargeStyles,
      children: [jsx(Typography, {
        variant: "heading2",
        css: getAmountHeadingStyles,
        children: jsx("h2", {
          children: price
        })
      }), showTaxInfo && jsx("small", {
        css: getAmountTaxStyles,
        children: t('service-card.price.tax-info', {
          appliedTax: appliedTax !== null && appliedTax !== void 0 ? appliedTax : ''
        })
      })]
    }), managementFee && jsx(Typography, {
      variant: "small",
      css: getFeeStyles,
      children: t('service-card.price.management-fee-info', {
        amount: Currency.format(managementFee.basePrice || 0, managementFee.currency)
      })
    }), jsx(Button, {
      css: getButtonStyles,
      onClick: onPriceSelect,
      variant: ButtonVariant.FILLED,
      "data-id": "book-service-button",
      children: jsx(Typography, {
        variant: "heading6",
        children: t('service-card.select.label')
      })
    })]
  });
};

export { Price };
//# sourceMappingURL=Price.js.map
